import React from 'react';
import { Box, Text, HStack, VStack, Badge, useColorModeValue } from '@chakra-ui/react';
import { getAriveStageLabel, getAriveStageColor } from '../../constants/ariveConstants';

export default function AriveLoanSummary({ loanData, ariveId, entityType }) {
  const bg = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  if (!loanData || !ariveId) {
    return null;
  }

  const currentStage = loanData.currentStage;
  const stageColor = getAriveStageColor(currentStage);

  return (
    <Box bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={3}>
      <VStack align="stretch" spacing={2}>
        <HStack justify="space-between">
          <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase" color="gray.500">
            Arive {entityType === 'lead' ? 'Lead' : 'Loan'} #{ariveId}
          </Text>
          {currentStage && (
            <Badge colorScheme={stageColor} fontSize="10px">
              {getAriveStageLabel(currentStage)}
            </Badge>
          )}
        </HStack>
        {loanData.baseLoanAmount && (
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.500">Loan Amount</Text>
            <Text fontSize="sm" fontWeight="medium">
              ${Number(loanData.baseLoanAmount).toLocaleString()}
            </Text>
          </HStack>
        )}
        {loanData.noteRate != null && (
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.500">Rate</Text>
            <Text fontSize="sm" fontWeight="medium">{loanData.noteRate}%</Text>
          </HStack>
        )}
        {loanData.lenderName && (
          <HStack justify="space-between">
            <Text fontSize="sm" color="gray.500">Lender</Text>
            <Text fontSize="sm" fontWeight="medium">{loanData.lenderName}</Text>
          </HStack>
        )}
      </VStack>
    </Box>
  );
}
